// API configuration
export const API_URL = "https://roambis.com/admin/public/api";
// export const API_URL =
//   "https://testingbackend.infinityfreeapp.com/backend/public/api";
// export const API_URL = "http://127.0.0.1:8000/api";
export const BASE_URL = "https://roambis.com/";
